import { prebuildData } from "../../../../lib/prebuild-data";
import { EventPane } from "../../../core/event_pane";

export type FilterBarIconButtonProps = {
    name: string;
    selected?: boolean;
    onClick?: () => void;
    paneClassNames?: string[];
    hint?: string;
};

export function FilterBarIconButton({name,selected,onClick = () => {},paneClassNames,hint}:FilterBarIconButtonProps)
{
    const { collectionFilterControls: { highlightColor,hoverColor,color } } = prebuildData.getActiveTheme();

    return (
        <>
            <div className={"wrapper"+(selected?" selected":"")}>
                <div className={"container"}>
                    <div className="frame">
                        <i className={`icon-collection-filterbar-${name} icon`}  />
                    </div>
                    <div className="frame selected">
                        <i className={`icon-collection-filterbar-${name}-selected icon`}  />
                    </div>
                    <EventPane onClick={onClick} paneClassNames={paneClassNames} hint={hint} />
                </div>
            </div>
            <style jsx>{`
            .container {
                --height: 68rem;
                position: relative;
                width: 100%;
                height: var(--height);
            }

            .frame {
                position: absolute;
                left: 0rem;
                top: 0rem;
                width: 100%;
                height: 100%;                
                text-align: center;
                visibility: hidden;
                opacity: 0;
                --duration: calc(var(--action-switch-transition-duration) * 0.7);
                --delay: var(--duration);                
                transition: visibility var(--duration) ease var(--delay), opacity var(--duration) ease var(--delay);
                z-index: -2;
            }

            .wrapper:not(.selected) .frame:not(.selected),.wrapper.selected .frame.selected {
                visibility: visible;
                opacity: 1;
                transition: visibility var(--duration), opacity var(--duration);
                z-index: -1;
            }
            
            .icon {
                font-size: 32rem;
                line-height: var(--height);
                color: ${color};
            }

            .frame.selected .icon {
                color: ${highlightColor};
            }

            .container.hover .frame:not(.selected) .icon {
                color: ${hoverColor};
            } 

            .container.touchdown {
                background-color: rgba(0,0,0,0.03);
            }

            @media screen and (max-width: 1300px) and (max-height: 775px) {
                .container {
                    --height: 60rem;
                }

                .icon {
                    font-size: 30rem;
                }
            }      

            `}</style>
        </>
    );
}